define((require, exports, module) => {
    'use strict';

    const BillingService = require('./BillingService');

    const billingService = new BillingService({});

    module.exports = billingService;
});
